import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-receipt-page',
  templateUrl: './receipt-page.component.html',
  styleUrls: ['./receipt-page.component.scss'],
})
export class ReceiptPageComponent implements OnInit {
  invoiceId?: string;
  tenantId?: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const params = this.route.snapshot.params;
    this.invoiceId = params['id'];
    this.tenantId = this.authService.currentUser?.tenant_id;
  }
}

